<template>
  <div class="nav-container">
    <header class="nav-header">
      <div class="header-left">
        <span class="system-title">研发产品门户</span>
      </div>
    </header>

    <main class="nav-content">
      <div v-for="module in modulesData" :key="module.id" class="module-section">
        <h3 class="module-title">
          <i class="el-icon-menu"></i>
          <el-image style="width: 30px; height: 30px" :src="$utils.imgTrow(module.icon)" fit="cover" :preview-src-list="[ $utils.imgTrow(module.icon) ]" v-if="module.icon"></el-image>
          {{ module.name }}
        </h3>
        
        <div class="product-grid">
          <el-card 
            v-for="envItem in module.environments" 
            :key="envItem.id" 
            shadow="hover" 
            class="product-card"
            @click.native="goToUrl(envItem.url)">
            <div class="product-item">
              <div class="prod-icon">
                <i :class="getEnvIcon(envItem.env.name)"></i>
              </div>
              <div class="prod-info">
                <span class="prod-label">{{ envItem.env.name }}</span>
                <span class="prod-desc" :title="envItem.url">点击跳转系统</span>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      // 模块化、多环境、多地域的数据结构
      modulesData: []
    };
  },
  created() {
    this.getProductDetail();
  },
  methods: {
    getProductDetail() {
      this.$api.productsAll().then(res => {
        if (res.code == 200) {
          this.modulesData = res.data
        }
      })
    },
    getEnvIcon(envName) {
      // if (envName.includes('国内')) return 'el-icon-office-building';
      // if (envName.includes('越南')) return 'el-icon-location-outline';
      // if (envName.includes('东南亚')) return 'el-icon-position';
      // if (envName.includes('欧美')) return 'el-icon-map-location';
      return 'el-icon-link'; // 默认图标
    },
    goToUrl(url) {
      if (url) {
        window.open(url, '_blank');
      } else {
        this.$message.warning('该环境未配置跳转链接');
      }
    },
  }
}
</script>
<style scoped lang="scss">
.nav-container {
  min-height: 100vh;
  background-color: #f0f2f5;
}

/* 顶部导航 */
.nav-header {
  height: 60px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
}
.system-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}
.user-info {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #606266;
}

/* 主体布局 */
.nav-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
}

/* 功能模块区块 */
.module-section {
  margin-bottom: 40px;
}
.module-title {
  font-size: 18px;
  color: #303133;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.module-title i {
  color: #409EFF;
}

/* 覆盖Element-ui的border-card样式，使其更清爽 */
.env-tabs {
  border: none !important;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05) !important;
  border-radius: 8px;
  overflow: hidden;
}
::v-deep .el-tabs__nav-wrap {
  background-color: #fafafa;
}

/* 产品卡片栅格 */
.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;
  padding: 10px 5px;
}
.product-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #e4e7ed;
}
.product-card:hover {
  transform: translateY(-4px);
  border-color: #409EFF;
}

/* 卡片内布局 */
.product-item {
  display: flex;
  align-items: center;
  gap: 15px;
}
.prod-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: #ecf5ff;
  color: #409EFF;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}
.prod-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.prod-label {
  font-size: 15px;
  font-weight: 500;
  color: #303133;
}
.prod-desc {
  font-size: 12px;
  color: #909399;
}
</style>